import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { enrichLineItemFields } from "../utils/taxCalculations";

export const PercentageDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const tillData = useAuthStore.getState().tillData;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let modificationsMade = false; // Flag to indicate modifications
  let totalDiscountAmount = 0;
  let totalNet = 0;
  let totalTax = 0;
  // Iterate through each item in the cart
  cartObj.items.map((item) => {
    let excludingFlag = true;
    const matchingCategory = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategory && pricingRule.mPricingPcategories.length > 0) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);
    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);
    if (
      (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
      (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    let pricingRuleFlag = true;

    // Apply additional logic for pricingRuleFlag based on your requirements

    if (item.discount <= 0 && item.mPricingRulesId !== null && item.mPricingRulesId !== undefined) {
      pricingRule.mPricingXProducts.forEach((res) => {
        if (res.mProductId === item.productId) {
          delete item.priority;
        }
      });
    }

    if (
      saleTypeValidation &&
      excludingFlag &&
      pricingRuleFlag &&
      (product.productId === item.productId || iscoupon || removeDiscounts) &&
      (item?.priority ? item?.priority < pricingRule.priority : true)
    ) {
      const offerIndex =
        pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "N"
          ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId)
          : pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "Y"
            ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId !== item.productId)
            : 0;

      // if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRule.minimumQty) {
      //   const discountAmt = ((pricingRule.percentageDiscount / 100) * parseFloat(item.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);
      //   const sp = parseFloat(item.realPrice) - discountAmt;
      //   const mrp = parseFloat(sp) * item.weight;
      //   let tax;
      //   if (Array.isArray(item.children) && item.children.length > 0) {
      //     tax = item.children.reduce((sum, child) => sum + (child.taxAmount || 0), 0);
      //   } else {
      //     tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
      //   }
      //   // const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
      //   item.salePrice = sp;
      //   item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.nettotal =
      //     taxIncludeFlag === "Y"
      //       ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
      //       : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.discount = parseFloat((discountAmt * item.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      //   item.discountName = pricingRule.printedName;
      //   item.mPricingruleId = pricingRule.mPricingrulesId;
      //   item.nextRule = pricingRule.nextRule;
      //   item.iscoupon = iscoupon;
      //   item.couponInput = couponInput;
      //   item.referenceId = uniqReferenceId;
      //   item.mPricingCouponId = mPricingCouponId;
      //   item.priority = pricingRule.priority;
      //   modificationsMade = true;
      //   // Modifications made for the current item
      // }

      if (offerIndex >= 0 && Math.abs(item.weight) >= (pricingRule.minimumQty || 0)) {
        const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

        const maxQty = pricingRule.maximumQty ? Math.abs(pricingRule.maximumQty) : null;
        const itemQty = Math.abs(item.weight);

        const applicableQty = maxQty ? Math.min(itemQty, maxQty) : itemQty;
        const remainingQty = maxQty ? Math.max(itemQty - maxQty, 0) : 0;

        // Discounted Part
        const realPriceNum = parseFloat(item.realPrice);
        let discountAmt = ((pricingRule.percentageDiscount / 100) * realPriceNum).toFixed(prcPrecision);
        // TSK-3145: cap at the item's own per-unit realPrice so a misconfigured
        // percentageDiscount > 100 can never push discountedSP/nettotal negative.
        discountAmt = realPriceNum >= 0 && parseFloat(discountAmt) > realPriceNum ? realPriceNum.toFixed(prcPrecision) : discountAmt;
        const discountedSP = realPriceNum - discountAmt;

        const discountedMRP = discountedSP * applicableQty;

        const discountedTax = taxIncludeFlag === "Y" ? discountedMRP - discountedMRP / (1 + item.taxRate / 100) : (discountedMRP * item.taxRate) / 100;

        // Non-discounted Part
        const normalMRP = parseFloat(item.realPrice) * remainingQty;

        const normalTax = taxIncludeFlag === "Y" ? normalMRP - normalMRP / (1 + item.taxRate / 100) : (normalMRP * item.taxRate) / 100;

        // Final merge
        const totalMRP = discountedMRP + normalMRP;
        const totalTaxItem = discountedTax + normalTax;

        item.salePrice = discountedSP;
        item.taxAmount = parseFloat(totalTaxItem.toFixed(prcPrecision));

        item.nettotal = taxIncludeFlag === "Y" ? parseFloat(totalMRP.toFixed(prcPrecision)) : parseFloat((totalMRP + totalTaxItem).toFixed(prcPrecision));

        item.discount = parseFloat((discountAmt * applicableQty).toFixed(prcPrecision));

        item.discountName = pricingRule.printedName;
        item.mPricingruleId = pricingRule.mPricingrulesId;
        item.nextRule = pricingRule.nextRule;
        item.iscoupon = iscoupon;
        item.couponInput = couponInput;
        item.referenceId = uniqReferenceId;
        item.mPricingCouponId = mPricingCouponId;
        item.priority = pricingRule.priority;
        enrichLineItemFields(item, taxIncludeFlag, prcPrecision);

        modificationsMade = true;
      } else {
        const mrp = parseFloat(item.realPrice) * item.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
        item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.nettotal =
          taxIncludeFlag === "Y"
            ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
            : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.discount = 0;
        item.discountName = "";
        item.mPricingruleId = null;
        delete item.nextRule;
        enrichLineItemFields(item, taxIncludeFlag, tillData.tillAccess.csBunit.currencies[0].prcPrecision);
      }
    }
    totalDiscountAmount += item.discount || 0;
    totalNet += item.nettotal || 0;
    totalTax += item.taxAmount || 0;
  });

  if (modificationsMade) {
    // Update the cart object with the adjusted items
    let couponsData = cartObj.couponInput?.length > 0 ? [...cartObj.couponInput] : [];
    if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null && mPricingRulesId) {
      // couponsData.push({ couponCode: couponInput || pricingRule.name, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
      couponsData.push({
        couponCode: couponInput && couponInput.trim() !== "" ? couponInput : pricingRule.name,
        referenceId: uniqReferenceId,
        mPricingCouponId: mPricingCouponId,
        mPricingruleId: mPricingRulesId,
      });
    }
    const adjustedCartObj = {
      ...cartObj,
      items: cartObj.items,
      iscoupon: iscoupon,
      couponInput: couponsData,
      discount: parseFloat(totalDiscountAmount?.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      total: parseFloat(totalNet?.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      tax: parseFloat(parseFloat(totalTax)?.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      subTotal: parseFloat(parseFloat(totalNet - totalTax)?.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
    };
    if (isExchange) {
      useCartStore.getState().setExchangeCart(adjustedCartObj);
    } else {
      setCart(adjustedCartObj);
    }
    return adjustedCartObj;
  }
};
